import React from 'react'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube, FaWhatsapp  } from 'react-icons/fa'
import { FooterContainer, FooterWrap, SocialIconLink, SocialIcons, SocialLogo, SocialMedia, SocialMediaWrap, WebsiteRights } from './FooterElements'
import { animateScroll as scroll } from 'react-scroll';

const Footer = () => {
   const toggleHome = () => {
      scroll.scrollToTop();
   }

   return (
      <FooterContainer>
         <FooterWrap>
         <SocialMedia>
            <SocialMediaWrap>
               <SocialLogo to='/' onClick={toggleHome}>
               Balma
               </SocialLogo>
               <WebsiteRights>BalmaDev © {new Date().getFullYear()} All rights reserved.</WebsiteRights>
               <SocialIcons>
               <SocialIconLink href='https://www.facebook.com/profile.php?id=61583405920822' target='_blank' arial-label='Facebook'>
                  <FaFacebook />
               </SocialIconLink>
               <SocialIconLink href='//www.instagram.com/rafaellbalmant/' target='_blank' arial-label='Instagram'>
                  <FaInstagram/>
               </SocialIconLink>
               <SocialIconLink href='https://wa.link/uvvu0r' target='_blank' arial-label='Youtube'>
                  <FaWhatsapp />
               </SocialIconLink>
               <SocialIconLink href='' target='_blank' arial-label='Twitter'>
                  <FaTwitter/>
               </SocialIconLink>
               <SocialIconLink href='' target='_blank' arial-label='GitHub'>
                  <FaYoutube />
               </SocialIconLink>
               <SocialIconLink href='' target='_blank' arial-label='Linkedin'>
                  <FaLinkedin />
               </SocialIconLink>
               </SocialIcons>
            </SocialMediaWrap>
         </SocialMedia>
         </FooterWrap>
      </FooterContainer>
   )
}

export default Footer